module.exports = __webpack_public_path__ + "static/official_website_new/img/7.e56e04fe.png";